<!-- 发票提取单据 -->
<template>
   <div>
      <el-form :inline="true" class="demo-form-inline" size="mini">
         <el-form-item label="开始日期">
            <el-date-picker v-model="invoiceExtractData.start" type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日"
               value-format="timestamp">
            </el-date-picker>
         </el-form-item>
         <el-form-item label="结束日期">
            <el-date-picker @change="changeTime" v-model="invoiceExtractData.end" type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日"
               value-format="timestamp">
            </el-date-picker>
         </el-form-item>
         <el-form-item>
            <el-button type="primary" size="mini" @click="searchData">查询</el-button>
            <el-button :disabled="returnObj.mainData.length <= 0" size="mini" @click="sureDetail"
               style="margin-left: 60px" type="primary">确认选择</el-button>
         </el-form-item>
      </el-form>
      <!-- 表格 -->
      <el-table ref="moviesTable" height="420" size="mini" style="width: 100%" :data="mainData" border stripe
         highlight-current-row :header-cell-style="getHeaderCellStyle" @row-dblclick="dblclick"
         @selection-change="handleSelectionChange">
         <el-table-column type="selection" width="50"></el-table-column>
         <el-table-column align="center" min-width="150" prop="sdmId" label="业务单号"
            :show-overflow-tooltip="true"></el-table-column>
         <el-table-column align="center" min-width="150" prop="cmName" label="单位名称"
            :show-overflow-tooltip="true"></el-table-column>
         <el-table-column align="center" min-width="120" prop="totalMoney" label="总金额"
            :show-overflow-tooltip="true"></el-table-column>
         <el-table-column align="center" min-width="120" prop="billType" label="发票类型"
            :show-overflow-tooltip="true"></el-table-column>
         <el-table-column align="center" min-width="120" prop="createrName" label="创建人"
            :show-overflow-tooltip="true"></el-table-column>
         <el-table-column align="center" min-width="120" prop="remark" label="备注"
            :show-overflow-tooltip="true"></el-table-column>
         <el-table-column align="center" min-width="120" prop="createTime" label="创建时间" :show-overflow-tooltip="true">
            <template slot-scope="scope">
               <span v-if="scope.row.createTime">
                  {{ $common.getLocalTime(scope.row.createTime) }}
               </span>
            </template>
         </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
         :page-sizes="pageSizes" background :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
         :total="total">
      </el-pagination>
   </div>
</template>

<script>
export default {
   name: "selectInvoiceExtract",
   components: {},
   data() {
      return {
         opmId: "",
         ormId: "",
         activeName: "1",//默认展开
         showdetail: true,
         currentPage: 1,
         pageSizes: [30, 500, 1000, 5000],
         pageSize: 30,
         total: 0,
         mainData: [],
         selectedDataIndexList: [],
         isPagination: "",
         searchTermList: [], //检索条件
         Columns: [],
         ColumnsDetail: [],
         isDetail: false,
         multipleSelection: [], //数组内层
         returnObj: {//外层对象数据
            mainData: [],
            decaSudrawExtractmasterVos: [],
            decaSudrawExtractdetailVos: [],
         },
      };
   },

   props: {
      invoiceExtractData: {
         type: Object,
         require: true
      },
   },
   watch: {},
   computed: {},
   mounted() { },
   created() {
      // 处理组件需要的数据
      this.opmId = JSON.parse(sessionStorage.getItem("userInfo")).opmId
      this.getTableMainList()
   },
   methods: {
      changeTime(val) {
         if (val) {
            var time = val + 24 * 60 * 60 * 1000 - 1;
            this.invoiceExtractData.end = time;
         }
      },
      // 切换显示条数
      setDataPageSize(val) {
         this.getRequestData.page = 1
         this.getRequestData.rows = val
         this.getTableMainList()
      },
      searchData() {
         this.returnObj.mainData = []
         this.getTableMainList()
      },
      dblclick(row) {
         var flag = false
         this.returnObj.mainData.forEach((item, index) => {
            if (item.sdmId == row.sdmId) {
               flag = true
               this.$refs.moviesTable.toggleRowSelection(row, false)
               this.returnObj.mainData.splice(index, 1)
            }
         })
         if (!flag) {
            this.$refs.moviesTable.toggleRowSelection(row, true)
            this.returnObj.mainData.push(row)
         }
      },
      handleSelectionChange(val) {
         this.returnObj.mainData = val
         if (this.returnObj.mainData.length > 0) {
            this.selectedDataIndexList = this.returnObj.mainData.map(item => item.sdmId)
            this.getTableDetailList()
         }
      },
      //确认选择
      sureDetail() {
         this.returnObj.decaSudrawExtractmasterVos.sort(function (a, b) {
            return b.createTime - a.createTime
         })
         this.returnObj.decaSudrawExtractdetailVos.sort(function (a, b) {
            return b.createTime - a.createTime
         })
         const uniqueIds = [...new Set(this.selectedDataIndexList)]
         this.$emit("invoiceExtractMethods", {
            mainData: this.returnObj.decaSudrawExtractmasterVos,
            detailData: this.returnObj.decaSudrawExtractdetailVos,
            selectedDataIndexList: uniqueIds,
            isDetail: true
         });
      },
      // 获取主表格
      async getTableMainList() {
         let res = await this.$http.extractSudrawbill(this.invoiceExtractData)
         if (res && res.status == 200) {
            this.mainData = res.result.list; //默认第一条
            this.total = res.result.total
         } else {
            this.$message({
               message: res.message,
               type: 'error'
            });
            this.$emit("invoiceExtractMethods", '')
            return false
         }
      },
      // 获取明细表格
      async getTableDetailList() {
         const uniqueIds = [...new Set(this.selectedDataIndexList)]
         let res = await this.$http.extractDetail({ "ids": uniqueIds })
         if (res.status == 200) {
            this.returnObj.decaSudrawExtractdetailVos = res.result.decaSudrawExtractdetailVos
            this.returnObj.decaSudrawExtractmasterVos = res.result.decaSudrawExtractmasterVos
         } else {
            this.$message({
               message: res.message,
               type: 'error'
            });

         }
      },
      //分页
      handleSizeChange(val) {
         this.pageSize = val;
         this.invoiceExtractData.rows = val;
         this.getTableMainList();
      },
      // 分页
      handleCurrentChange(val) {
         this.currentPage = val;
         this.invoiceExtractData.page = val;
         this.getTableMainList();
      },
      //   -----------------------------------------------------
      getHeaderCellStyle() {
         return "background: skybule; borderBottom: solid 1px #5a5e66;color: #3e5569";
      },
      getHeaderCellStyleD() {
         return "background: skybule;color: #3e5569";
      },

   },
};
</script>

<style scoped>
.el-pagination {
   padding: 20px 0px 5px;
}
</style>
